import axios, { AxiosInstance } from 'axios';
import config from '../config';
import { getAuthToken, setupAuthInterceptor } from '../utils';
import { History } from 'history';

export const configurePaymentService = (service: AxiosInstance) => {
  service.interceptors.request.use(
    async (config) => {
      const token = await getAuthToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    },
  );
};

export const createPaymentService = (history?: History): AxiosInstance => {
  const paymentService = axios.create({
    baseURL: config.paymentServiceURL,
  });

  setupAuthInterceptor(paymentService, history);

  return paymentService;
};

const paymentService = createPaymentService();
configurePaymentService(paymentService);
export { paymentService };
